import { injectable } from 'inversify';
import { Route } from 'react-router';

import IWebModule from 'targets/web/types/IWebModule';

import { DisplayPageLayout } from './components/DisplayPageLayout/DisplayPageLayout';
import { TournamentDisplayPageLayout } from './components/tournament/TournamentDisplayPageLayout/TournamentDisplayPageLayout';
import { DisplayNavigationRoutes } from './navigation/DisplayNavigationRoutes';
import { ContestInProgress } from './views/ContestInProgress.view';
import { ResultsScreen } from './views/Results.view';
import { TournamentsView } from './views/Tournaments.view';
import { WaitingRoom } from './views/WaitingRoom.view';

@injectable()
class DisplayModule implements IWebModule {
  getRoutes(): JSX.Element {
    return (
      <>
        <Route element={<TournamentDisplayPageLayout />} path={DisplayNavigationRoutes.Tournaments}>
          <Route
            path={DisplayNavigationRoutes.TournamentsWithLocationName}
            element={<TournamentsView />}
          />
        </Route>
        <Route element={<DisplayPageLayout />} path="/:locationId/:bayId">
          <Route path={DisplayNavigationRoutes.WaitingRoom} element={<WaitingRoom />} />
          <Route path={DisplayNavigationRoutes.ContestInProgress} element={<ContestInProgress />} />
          <Route path={DisplayNavigationRoutes.Results} element={<ResultsScreen />} />
        </Route>
      </>
    );
  }
}

export default DisplayModule;
